import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const staticApi = createApi({
  reducerPath: "staticApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + `statics`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token; // ✅ بدون store
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  // /topup/init
  // fetch(`/api/seo/${encodeURIComponent(path)}`)
  //   .
  endpoints: (builder) => ({
    getSliderPage: builder.query({
      query: () => {
        return {
          url: `promo?page=1&limit=50&sort=-createdAt&type=slider`,
          method: "GET",
        };
      },
    }),
    getAboutPage: builder.query({
      query: () => {
        return {
          url: `/about`,
          method: "GET",
        };
      },
    }),
    getContactPage: builder.query({
      query: () => {
        return {
          url: `/contact`,
          method: "GET",
        };
      },
    }),
    getPolicyPage: builder.query({
      query: () => {
        return {
          url: `/rule`,
          method: "GET",
        };
      },
    }),
    getFooterData: builder.query({
      query: () => {
        return {
          url: `/footer`,
          method: "GET",
        };
      },
    }),
    getCities: builder.query({
      query: () => {
        return {
          url: `/state?limit=50`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetAboutPageQuery,
  useGetContactPageQuery,
  useGetPolicyPageQuery,
  useGetFooterDataQuery,
  useGetCitiesQuery,
  useGetSliderPageQuery
} = staticApi;
